import { uuidGenerator } from "../../../utils";

export const parseDirections = directions =>
  directions.length
    ? directions
        .split(/\r|\n/)
        .filter(x => x.length)
        .map(line => {
          const [text, miles] = line.split(/\s+(?=(\d+(\.\d+)?\sMILES))/);

          return {
            id: uuidGenerator(),
            text: text || "",
            miles: parseFloat(miles) || 0
          };
        })
    : [{ miles: 0 }];
